var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"footer-left"},[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" ")]),_c('div',{staticClass:"footer-right"},[_vm._v(" V1.0 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }